import numeral from 'numeral'

numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number) {
        return number === 1 ? 'uno' : 'cero';
    },
    currency: {
        symbol: '$'
    }
})

numeral.locale('es')

export default numeral
